export default __webpack_public_path__ + "media/images/logos/consultancy-74f168c4a26af87f796b293ad2937f07.svg";